var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRoundChevron = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.377 14.058c.037.426-.105.865-.43 1.19L12.994 23.2a1.498 1.498 0 0 1-2.12-.004l-.865-.864a1.504 1.504 0 0 1-.003-2.12l6.134-6.134-5.035-5.036-1.016-1.016a1.498 1.498 0 0 1-.006-2.119L10.991 5a1.5 1.5 0 0 1 2.122.01l7.828 7.827c.333.333.479.785.436 1.22z"
  })));
};
export default SvgRoundChevron;